import {
  Alert,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
const number = (value) =>
  new Intl.NumberFormat('pl-PL', { maximumFractionDigits: 3 }).format(value);
const date = (value) =>
  value?.slice(0, 10).split('-').reverse().join('.') ?? '—';
const days = (value) => `${value} ${value === 1 ? 'dzień' : 'dni'}`;
export default function ShelfLifeOptions({ item }) {
  const alternatives = item.shortDatedAlternatives ?? [];
  const expired = item.expiredStock ?? [];
  if (
    item.shortDatedAlternatives === undefined &&
    item.insufficientShelfLifeQuantity > 0
  )
    return (
      <Alert severity="info">
        Przelicz transporty, aby zobaczyć daty partii.
      </Alert>
    );
  if (!alternatives.length && !expired.length) return null;
  return (
    <Stack spacing={1}>
      {alternatives.length > 0 && (
        <>
          <Typography variant="h6">Daty i partie</Typography>
          <Typography>Wymagany termin: {date(item.minimumExpiry)}.</Typography>
          <Typography variant="body2">
            Wymagana akceptacja daty. Zapas nie jest zarezerwowany.
          </Typography>
          <TableContainer>
            <Table size="small" aria-label="Partie z krótszym terminem">
              <TableHead>
                <TableRow>
                  {[
                    'Termin partii',
                    'Odstępstwo od wymagania',
                    'Pozostała przydatność w dniu załadunku',
                    'Warunkowe pokrycie',
                    'Dostępne w wierszu zapasu',
                    'Skład / obszar / bin',
                    'Partia',
                  ].map((h) => (
                    <TableCell key={h}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {alternatives.map((lot) => (
                  <TableRow key={lot.stockId}>
                    <TableCell>{date(lot.expiresAt)}</TableCell>
                    <TableCell>{days(lot.daysShort)} za krótko</TableCell>
                    <TableCell>
                      {days(lot.remainingShelfLifeDays)}
                      {lot.remainingShelfLifeDays === 0
                        ? ' — termin upływa w dniu załadunku'
                        : ''}
                    </TableCell>
                    <TableCell>
                      {number(lot.potentialQuantity)} {item.unit}
                    </TableCell>
                    <TableCell>
                      {number(lot.availableQuantity)} {item.unit}
                    </TableCell>
                    <TableCell>
                      {lot.storageLocation} /{' '}
                      {lot.area === 'CONVEYOR' ? 'Transporter' : lot.area} /{' '}
                      {lot.bin}
                    </TableCell>
                    <TableCell>{lot.batch ?? 'Brak numeru partii'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
      {expired.length > 0 && (
        <>
          <Alert severity="error">
            Zapas przeterminowany na dzień załadunku — nie używaj.
          </Alert>
          <TableContainer>
            <Table size="small" aria-label="Zapas przeterminowany">
              <TableHead>
                <TableRow>
                  {[
                    'Termin partii',
                    'Po terminie w dniu załadunku',
                    'Ilość wykluczona',
                    'Skład / obszar / bin',
                    'Partia',
                  ].map((h) => (
                    <TableCell key={h}>{h}</TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {expired.map((lot) => (
                  <TableRow key={lot.stockId}>
                    <TableCell>{date(lot.expiresAt)}</TableCell>
                    <TableCell>{days(-lot.remainingShelfLifeDays)}</TableCell>
                    <TableCell>
                      {number(lot.availableQuantity)} {item.unit}
                    </TableCell>
                    <TableCell>
                      {lot.storageLocation} /{' '}
                      {lot.area === 'CONVEYOR' ? 'Transporter' : lot.area} /{' '}
                      {lot.bin}
                    </TableCell>
                    <TableCell>{lot.batch ?? 'Brak numeru partii'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </>
      )}
    </Stack>
  );
}
